import { render, staticRenderFns } from "./MemberAddressBook.vue?vue&type=template&id=14dfd7aa"
import script from "./MemberAddressBook.vue?vue&type=script&lang=js"
export * from "./MemberAddressBook.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports